export const CONTACT = {
  email: "mamta_mathpal@Tranzlytics.com",
  phones: ["+91-8447499905", "+91-8273499905"],
  phoneLinks: ["tel:+918447499905", "tel:+918273499905"],
  address: "Noida, Delhi NCR, India",
  hours: "Mon – Sat, 9:30 AM – 7:00 PM IST",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1601132359864-c974e79890ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxodW1hbm9pZCUyMHJvYm90JTIwd2hpdGUlMjBmdXR1cmlzdGljJTIwbGlnaHR8ZW58MHx8fHwxNzkzNzE1MDk3fDA&ixlib=rb-4.1.0&q=85",
  dataCenter: "https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  serverFans: "https://images.unsplash.com/photo-1791158669894-a043b640c8fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMEFJJTIwYnJhaW4lMjBnbG93aW5nJTIwbmV1cmFsJTIwbmV0d29yayUyMGRpZ2l0YWwlMjBub2Rlc3xlbnwwfHx8fDE3OTM3MTUwOTd8MA&ixlib=rb-4.1.0&q=85",
  founder: "https://images.unsplash.com/photo-1737644467636-6b0053476bb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxodW1hbm9pZCUyMHJvYm90JTIwd2hpdGUlMjBmdXR1cmlzdGljJTIwbGlnaHR8ZW58MHx8fHwxNzkzNzE1MDk3fDA&ixlib=rb-4.1.0&q=85",
  execDesk: "https://images.unsplash.com/photo-1562408590-e32931084e23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MTJ8MHwxfHNlYXJjaHwxfHxtaWNyb2NoaXAlMjBjaXJjdWl0JTIwYm9hcmQlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc5MzcxNTEwMnww&ixlib=rb-4.1.0&q=85",
  laptop: "https://images.unsplash.com/photo-1597673030062-0a0f1a801a31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkYXRhJTIwYW5hbHl0aWNzJTIwaGFyZHdhcmUlMjB0ZWNobm9sb2d5JTIwbGFwdG9wJTIwZGVza3RvcCUyMG9mZmljZXxlbnwwfHx8d2hpdGV8MTc5MzcxMzU0MHww&ixlib=rb-4.1.0&q=85",
  desktop: "https://images.unsplash.com/photo-1549108101-74503aa0b925?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkYXRhJTIwYW5hbHl0aWNzJTIwaGFyZHdhcmUlMjB0ZWNobm9sb2d5JTIwbGFwdG9wJTIwZGVza3RvcCUyMG9mZmljZXxlbnwwfHx8d2hpdGV8MTc5MzcxMzU0MHww&ixlib=rb-4.1.0&q=85",
  devSetup: "https://images.unsplash.com/photo-1613203713323-feb0a4b6fb19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBkYXRhJTIwYW5hbHl0aWNzJTIwaGFyZHdhcmUlMjB0ZWNobm9sb2d5JTIwbGFwdG9wJTIwZGVza3RvcCUyMG9mZmljZXxlbnwwfHx8d2hpdGV8MTc5MzcxMzU0MHww&ixlib=rb-4.1.0&q=85",
  printer: "https://images.unsplash.com/photo-1650094980833-7373de26feb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxvZmZpY2UlMjBuZXR3b3JrJTIwcHJpbnRlciUyMG11bHRpZnVuY3Rpb24lMjBwcmludGVyfGVufDB8fHx8MTc5MzcxMzYzOHww&ixlib=rb-4.1.0&q=85",
  ups: "https://images.unsplash.com/photo-1762163516269-3c143e04175c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxzZXJ2ZXIlMjBwb3dlciUyMHN1cHBseSUyMGhhcmR3YXJlfGVufDB8fHx8MTc5MzcxMzY0OHww&ixlib=rb-4.1.0&q=85",
  sound: "https://images.unsplash.com/photo-1561314105-e6ac04c2984a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxjb25mZXJlbmNlJTIwc3BlYWtlciUyMGF1ZGlvJTIwc3lzdGVtfGVufDB8fHx8MTc5MzcxMzY1Mnww&ixlib=rb-4.1.0&q=85",
  panel: "https://images.unsplash.com/photo-1694253987646-353954f1889d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxODl8MHwxfHNlYXJjaHwxfHxpbnRlcmFjdGl2ZSUyMHRvdWNoc2NyZWVuJTIwZGlzcGxheSUyMHNtYXJ0JTIwYm9hcmQlMjBkYXNoYm9hcmQlMjBlbXB0eSUyMHJvb218ZW58MHx8fHwxNzkzNzE1MDk3fDA&ixlib=rb-4.1.0&q=85",
  rack: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByYWNrJTIwZXRoZXJuZXQlMjBzd2l0Y2glMjBjYWJsaW5nfGVufDB8fHx8MTc5MzcxMzY0Mnww&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1577412647305-991150c7d163?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBlbXB0eSUyMHRlY2glMjBvZmZpY2UlMjB3b3Jrc3BhY2UlMjBkZXNpZ24lMjBubyUyMHBlb3BsZXxlbnwwfHx8fDE3OTM3MTUwOTd8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/services", label: "Services", testid: "nav-link-services" },
  { to: "/products", label: "Products", testid: "nav-link-products" },
  { to: "/about", label: "About", testid: "nav-link-about" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const SERVICES = [
  {
    id: "data-engineering",
    num: "01",
    title: "Data Engineering & Analytics",
    blurb:
      "We architect resilient ETL/ELT pipelines, dimensional data marts and analytics layers that turn raw operational data into boardroom-ready intelligence.",
    points: [
      "ETL/ELT pipeline design & orchestration",
      "Data warehousing & data mart architecture",
      "Data quality, governance & tokenization",
      "KPI engineering & campaign analytics",
    ],
  },
  {
    id: "cloud-migration",
    num: "02",
    title: "Cloud Migration — Snowflake & Databricks",
    blurb:
      "End-to-end migration factory: we move legacy workloads from SAS, Teradata, Oracle and SQL Server into Snowflake and Databricks on AWS, Azure or GCP — without business disruption.",
    points: [
      "SAS / Teradata / Oracle / SQL Server source extraction",
      "Snowflake warehouse & Databricks lakehouse landing",
      "Python / PySpark code conversion at scale",
      "In-database optimisation — up to 80% run-cost reduction",
    ],
  },
  {
    id: "sas-onprem",
    num: "03",
    title: "SAS & On-Prem Database Expertise",
    blurb:
      "Deep hands-on mastery of legacy enterprise stacks — SAS Base/Advanced, SAS DI, SAS SMC, SAS Viya, Teradata, DB2 and Hadoop/Hive — maintained, tuned or modernised.",
    points: [
      "SAS Base / Advanced / DI / SMC / Viya administration",
      "Teradata, DB2, Oracle & SQL Server operations",
      "Batch scheduling with Control-M & Unix scripting",
      "Legacy modernisation roadmaps & audits",
    ],
  },
  {
    id: "networking",
    num: "04",
    title: "Enterprise Networking — End to End",
    blurb:
      "From structured cabling to secure switching and Wi-Fi, we design and commission complete office and campus networks, then stand behind them with SLA-backed support.",
    points: [
      "LAN/WAN design & structured cabling",
      "Switching, routing, firewalls & secure Wi-Fi",
      "Server-room & rack commissioning",
      "AMC & SLA-backed managed support",
    ],
  },
  {
    id: "ai-agentic",
    num: "05",
    title: "AI & Agentic AI Solutions",
    blurb:
      "From GenAI copilots on your warehouse to autonomous Agentic AI frameworks that audit, monitor and self-heal data pipelines — we put practical AI into production, not slide decks.",
    points: [
      "Agentic AI frameworks for pipeline ops & governance",
      "GenAI copilots over Snowflake / Databricks data",
      "LLM integration — RAG, vector search & evaluation",
      "MLflow model lifecycle & ML observability",
    ],
  },
  {
    id: "hardware",
    num: "06",
    title: "IT Hardware Supply & Support",
    blurb:
      "One procurement desk for laptops, desktops, printers, UPS systems, sound systems and interactive panels — genuine products, corporate billing and on-site warranty support.",
    points: [
      "Laptops, desktops & workstations",
      "Printers, UPS & power backup",
      "Sound systems & interactive panels",
      "Bulk procurement & financing assistance",
    ],
  },
];

export const PRODUCTS = [
  {
    id: "laptops",
    category: "computing",
    name: "Enterprise Laptops",
    image: IMAGES.laptop,
    blurb: "Business-grade notebooks built for analysts, engineers and executives.",
    specs: ["Dell Latitude, Lenovo ThinkPad, HP EliteBook, MacBook Pro", "Intel Core i5/i7/i9 & Apple M-series", "8–32 GB RAM, 512 GB–1 TB SSD", "3-year on-site OEM warranty"],
  },
  {
    id: "desktops",
    category: "computing",
    name: "Desktops & Workstations",
    image: IMAGES.desktop,
    blurb: "Tower and SFF desktops plus GPU workstations for heavy data workloads.",
    specs: ["Dell OptiPlex / Precision, HP Z-series", "Up to 64 GB ECC RAM, NVMe storage", "NVIDIA RTX options for ML workloads", "Custom imaging & domain join on delivery"],
  },
  {
    id: "printers",
    category: "print-power",
    name: "Printers & MFPs",
    image: IMAGES.printer,
    blurb: "High-volume network printers and multi-function devices for every floor.",
    specs: ["HP LaserJet, Canon imageRUNNER, Epson", "Mono & colour, A3/A4, duplex", "Network & secure PIN printing", "Toner supply & AMC plans"],
  },
  {
    id: "ups",
    category: "print-power",
    name: "UPS & Power Backup",
    image: IMAGES.ups,
    blurb: "Line-interactive and online UPS systems that keep racks and offices alive.",
    specs: ["APC, Microtek, Numeric — 1 kVA to 20 kVA", "Online double-conversion for server rooms", "Battery banks & runtime sizing", "Installation & battery replacement service"],
  },
  {
    id: "sound",
    category: "av-collab",
    name: "Sound Systems & AV",
    image: IMAGES.sound,
    blurb: "Conference-room audio, PA systems and AV integration that just works.",
    specs: ["JBL, Bose, Yamaha & Ahuja", "Boardroom & auditorium tuning", "Wireless mics & DSP mixers", "Complete cabling & commissioning"],
  },
  {
    id: "panels",
    category: "av-collab",
    name: "Interactive Panels",
    image: IMAGES.panel,
    blurb: "4K touch displays that turn boardrooms and classrooms into collaboration hubs.",
    specs: ["65\"–86\" 4K interactive flat panels", "Multi-touch, wireless screen casting", "Built-in Android + OPS Windows slot", "Wall-mount, trolley & training included"],
  },
];

export const PRODUCT_TABS = [
  { id: "all", label: "All Products" },
  { id: "computing", label: "Computing" },
  { id: "print-power", label: "Print & Power" },
  { id: "av-collab", label: "AV & Collaboration" },
];

export const TECH_STACK = ["Snowflake", "Databricks", "Agentic AI", "GenAI / LLMs", "PySpark", "SAS Viya", "Teradata", "Kafka", "Airflow", "dbt", "Delta Lake", "MLflow", "AWS", "Azure", "GCP", "BigQuery", "Control-M", "Docker", "Kubernetes", "Python"];

export const MARQUEE_ITEMS = [
  "Snowflake", "Databricks", "Agentic AI", "GenAI", "SAS Viya", "Teradata",
  "AWS", "Azure", "GCP", "Python", "PySpark", "Kafka", "Airflow", "dbt",
  "Delta Lake", "MLflow", "LangChain", "Vector DBs", "Kubernetes", "Docker",
  "BigQuery", "Dell", "HP", "Cisco", "Interactive Panels",
];

export const STATS = [
  { value: "15+", label: "Years of data engineering leadership" },
  { value: "200+", label: "Legacy SAS programs modernised" },
  { value: "80%", label: "Peak run-cost reduction delivered" },
  { value: "AI", label: "Agentic frameworks in production" },
];
